<template>
    <b-modal
        id="modal-historico-finalizacoes"
        title="Histórico de finalizações"
        size="xl"
        hide-footer
        scrollable
        @hidden="limpar"
    >
        <div
            v-if="loading"
            class="text-center py-5"
        >
            <i class="fas fa-spinner fa-spin fa-2x mb-3" />

            <div>
                Carregando histórico de finalizações...
            </div>
        </div>

        <template v-else>
            <div
                v-if="historico.length === 0"
                class="text-center py-5"
            >
                <img
                    src="/img/icons/robot.svg"
                    alt="Nenhum registro encontrado"
                    class="mb-4"
                    style="max-height: 130px"
                />

                <h5 class="font-weight-bold">
                    Nenhum histórico de finalização encontrado.
                </h5>

                <p class="text-muted mb-0">
                    As finalizações realizadas neste acolhimento aparecerão aqui.
                </p>
            </div>

            <b-table
                v-else
                :items="historico"
                :fields="fields"
                responsive
                striped
                hover
                small
                outlined
                stacked="md"
                table-class="mb-0"
            >
                <template v-slot:cell(data_finalizacao)="data">
                    <span class="text-nowrap">
                        {{ data.item.data_finalizacao || "-" }}
                    </span>
                </template>

                <template v-slot:cell(motivo)="data">
                    <div class="d-flex align-items-center">
                        <span
                            v-if="data.item.motivo_cor"
                            class="indicador-cor mr-2"
                            :style="{
                                backgroundColor:
                                    data.item.motivo_cor
                            }"
                        />

                        <strong>
                            {{ data.item.motivo || "Não informado" }}
                        </strong>
                    </div>
                </template>

                <template v-slot:cell(observacao)="data">
                    <div
                        v-if="data.item.observacao"
                        class="observacao-finalizacao"
                    >
                        {{ removerHtml(data.item.observacao) }}
                    </div>

                    <span
                        v-else
                        class="text-muted"
                    >
                        Não informada
                    </span>
                </template>

                <template v-slot:cell(usuario)="data">
                    {{ data.item.usuario || "-" }}
                </template>
            </b-table>
        </template>

        <div class="d-flex justify-content-end mt-4">
            <button
                type="button"
                class="btn btn-secondary"
                @click="fechar"
            >
                Fechar
            </button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "ModalHistoricoFinalizacoes",

    props: {
        historico: {
            type: Array,
            default: () => [],
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            fields: [
                {
                    key: "data_finalizacao",
                    label: "Data da finalização",
                    thStyle: {
                        width: "170px",
                        minWidth: "170px",
                    },
                },
                {
                    key: "motivo",
                    label: "Motivo",
                    thStyle: {
                        width: "230px",
                        minWidth: "230px",
                    },
                },
                {
                    key: "observacao",
                    label: "Observação",
                },
                {
                    key: "usuario",
                    label: "Técnico responsável",
                    thStyle: {
                        width: "210px",
                        minWidth: "210px",
                    },
                },
            ],
        };
    },

    methods: {
        fechar() {
            this.$bvModal.hide(
                "modal-historico-finalizacoes"
            );
        },

        limpar() {
            /*
             * O histórico pertence ao componente pai.
             * Não precisamos modificar a prop aqui.
             */
        },

        removerHtml(valor) {
            if (!valor) {
                return "";
            }

            const elemento =
                document.createElement("div");

            elemento.innerHTML = valor;

            return elemento.textContent ||
                elemento.innerText ||
                "";
        },
    },
};
</script>

<style scoped>
.indicador-cor {
    display: inline-block;
    width: 16px;
    height: 16px;
    min-width: 16px;
    border: 1px solid #ced4da;
    border-radius: 50%;
}

.observacao-finalizacao {
    max-width: 550px;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    word-break: break-word;
}
</style>